import ButtonV2 from 'atoms/components/Buttons/V2/ButtonV2';
import { TranslatableString } from 'i18n/translations/no';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface CustomToastProps {
  title?: TranslatableString;
  description?: TranslatableString;
  confirmAction?: () => void;
  cancelAction?: () => void;
}

const CustomToast: FC<
  CustomToastProps & {
    closeToast: () => void;
  }
> = ({
  title,
  description,
  confirmAction,
  closeToast,
  cancelAction,
}): JSX.Element => {
  const { t } = useTranslation();

  const handleClose = () => {
    if (cancelAction) {
      cancelAction();
    }

    closeToast();
  };

  const handleConfirmClick = () => {
    if (confirmAction) {
      confirmAction();
    }
    closeToast();
  };

  return (
    <div className="custom-toast">
      {title && <div className="title">{t(title)}</div>}
      {description && <div className="description">{t(description)}</div>}
      {confirmAction && (
        <div className="actions">
          <ButtonV2 size="s" type="tertiary" onClick={handleConfirmClick}>
            {t('Continue')}
          </ButtonV2>
          <ButtonV2 size="s" type="tertiary" onClick={handleClose}>
            {t('Cancel')}
          </ButtonV2>
        </div>
      )}
    </div>
  );
};

export default CustomToast;
